import { useRouteError, isRouteErrorResponse } from 'react-router';
import { Button } from '~/components/ui/button';

export function ErrorBoundary() {
  const error = useRouteError();
  let message = 'Something went wrong';
  let detail = '';

  if (isRouteErrorResponse(error)) {
    message = error.status === 404 ? 'Page not found' : `Error ${error.status}`;
    detail = error.statusText;
  } else if (error instanceof Error) {
    detail = error.message;
  }

  return (
    <div className="flex items-center justify-center h-full">
      <div className="text-center p-8">
        <h1 className="text-xl font-semibold text-foreground mb-2">{message}</h1>
        {detail && <p className="text-sm text-muted-foreground mb-4">{detail}</p>}
        <Button onClick={() => window.location.reload()}>
          Reload
        </Button>
      </div>
    </div>
  );
}
